/* Alternix core interactions — native JS, no bundler. */
const ready = callback => document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', callback, { once: true }) : callback();

function initStickyHeader() {
  const header = document.querySelector('.header-sticky-js');
  if (!header || header.dataset.nativeStickyReady) return;
  header.dataset.nativeStickyReady = 'true';
  let height = header.getBoundingClientRect().height;
  let lastScroll = window.scrollY, blockRevealUntil = 0, queued = false;
  const measure = () => {
    height = header.getBoundingClientRect().height;
    if (header.parentElement) header.parentElement.style.paddingTop = `${height}px`;
    header.style.position = 'fixed';
    document.querySelector('#clear-all')?.setAttribute('data-padding', `${height}px`);
  };
  const update = () => {
    queued = false;
    const y = window.scrollY;
    if (y <= height * 1.2) {
      header.classList.remove('header-sticky-hidden-js', 'header-sticky-visible-js');
    } else {
      header.classList.add('header-sticky-hidden-js');
      header.classList.toggle('header-sticky-visible-js', Date.now() > blockRevealUntil && y < lastScroll);
    }
    lastScroll = y;
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-mobile-facets-apply]')) {
      blockRevealUntil = Date.now() + 900;
      header.classList.remove('header-sticky-visible-js');
    }
  }, true);
  document.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  if (document.readyState === 'complete') measure();
  else window.addEventListener('load', measure, { once: true });
}

function initNestedAccordions(scope = document) {
  // Each control owns its neighbouring panel.  FAQ entries share a topic number,
  // so selecting panels by data-accordion-number would expand every answer.
  const wrappers = [];
  if (scope.matches?.('.nested-accordion-js')) wrappers.push(scope);
  wrappers.push(...scope.querySelectorAll('.nested-accordion-js'));

  wrappers.forEach(wrapper => {
    if (wrapper.dataset.nativeAccordionReady) return;
    wrapper.dataset.nativeAccordionReady = 'true';

    wrapper.addEventListener('click', event => {
      const tab = event.target.closest('.nested-accordion-tab-js');
      if (!tab || !wrapper.contains(tab)) return;
      event.preventDefault();

      const opening = tab.getAttribute('aria-expanded') !== 'true';
      tab.setAttribute('aria-expanded', String(opening));
      tab.classList.toggle('nested-accordion-active-icon-js', opening);

      if (tab.classList.contains('nested-accordion__topic-wrapper')) {
        // Contact template: a topic is followed by multiple question rows,
        // until the next topic button. Reveal only that topic's rows.
        let panel = tab.nextElementSibling;
        while (panel && !panel.classList.contains('nested-accordion__topic-wrapper')) {
          const next = panel.nextElementSibling;
          if (panel.classList.contains('nested-accordion__question-answer')) {
            panel.style.height = opening ? 'auto' : '0px';
            panel.toggleAttribute('data-accordion-active', opening);
            if (!opening) {
              panel.querySelectorAll('.nested-accordion-tab-js').forEach(child => {
                child.setAttribute('aria-expanded', 'false');
                child.classList.remove('nested-accordion-active-icon-js');
              });
              panel.querySelectorAll('.nested-accordion__answer-wrapper').forEach(answer => {
                answer.style.height = '0px';
                answer.removeAttribute('data-accordion-active');
              });
            }
          }
          panel = next;
        }
        return;
      }

      // FAQ and Contact question buttons have exactly one associated answer,
      // immediately after the button. Never toggle other rows sharing a number.
      const answer = tab.nextElementSibling;
      if (!answer?.classList.contains('nested-accordion__answer-wrapper')) return;
      answer.style.height = opening ? `${answer.scrollHeight}px` : '0px';
      answer.toggleAttribute('data-accordion-active', opening);
      if (opening) {
        const onEnd = ev => {
          if (ev.target !== answer || ev.propertyName !== 'height') return;
          answer.removeEventListener('transitionend', onEnd);
          if (tab.getAttribute('aria-expanded') === 'true') answer.style.height = 'auto';
        };
        answer.addEventListener('transitionend', onEnd);
      }
    });
  });
}

function initAccordions(scope = document) {
  const groups = ['.accordion--product-overview','.accordion--product-video','.accordion--product-delivery',
    '.accordion--product-reviews','.accordion--footer-links','.accordion--account-cards'];
  groups.forEach(selector => scope.querySelectorAll(selector).forEach(group => {
    if (group.dataset.nativeAccordionReady) return;
    group.dataset.nativeAccordionReady = 'true';
    const threshold = selector.includes('account-cards') ? 990 : selector.includes('footer-links') ? 750 : Infinity;
    const controls = [...group.querySelectorAll('[js-accordion="control"]')];
    const update = () => {
      const enabled = window.innerWidth <= threshold;
      group.querySelectorAll('[js-accordion="item"]').forEach((item, i) => {
        const content = item.querySelector('[js-accordion="content"], .accordion__content');
        const control = item.querySelector('[js-accordion="control"]');
        if (!content || !control) return;
        if (!enabled) { content.style.height = 'auto'; control.setAttribute('aria-expanded', 'true'); return; }
        const isOpen = item.dataset.nativeOpen === 'true';
        control.setAttribute('aria-expanded', String(isOpen));
        content.style.height = isOpen ? `${content.scrollHeight}px` : '0px';
      });
    };
    controls.forEach(control => control.addEventListener('click', event => {
      if (window.innerWidth > threshold) return;
      event.preventDefault();
      const selected = control.closest('[js-accordion="item"]');
      const willOpen = selected?.dataset.nativeOpen !== 'true';
      group.querySelectorAll('[js-accordion="item"]').forEach(item => { item.dataset.nativeOpen = 'false'; });
      if (selected) selected.dataset.nativeOpen = String(willOpen);
      update();
    }));
    update();
    window.addEventListener('resize', update, { passive: true });
  }));
}
ready(() => { initStickyHeader(); initNestedAccordions(); initAccordions(); });
document.addEventListener('shopify:section:load', event => {initNestedAccordions(event.target);initAccordions(event.target);});
